import {
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { ColorThemeService } from './common/services/color-theme.service';
import { StatisticService } from '@iv/shared/statistic.service';
import { Destroyer } from './common/utils';
import { interval } from 'rxjs';
import {
  skip,
  takeUntil
} from 'rxjs/operators';
import {PaymentWindowService} from './payment-window.service';

@Component({
  selector: 'iv-live-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends Destroyer implements OnInit, OnDestroy {

  constructor(
    private readonly colorThemeService: ColorThemeService,
    private readonly statisticService: StatisticService,

    private readonly paymentWindowService: PaymentWindowService
  ) {
    super();
  }

  private initDate;
  private lastActivityDate;
  private saveLastActivity;
  public ngOnInit() {
    this.paymentWindowService.showPaymentWindow();
    this.colorThemeService.ngOnInit();

    this.initDate = new Date();
    document.addEventListener('mousemove', this.saveLastActivity = () => {
      this.lastActivityDate = new Date();
    });

    interval(1000)
      .pipe(
        skip(1),
        takeUntil(this.destroy$)
      )
      .subscribe((value) => {
        if (value % 30 === 0) {
          this.statisticService.sendStatistic();
        }

        const now = (new Date()).getTime();
        if (this.initDate && (now - this.initDate.getTime()) > 86400000 &&
          (!this.lastActivityDate || (now - this.lastActivityDate.getTime()) > 300000)
        ) {
          window.location.reload();
        }

        this.statisticService.incrementPageTime();
        this.statisticService.incrementServiceTime();
      });
  }

  public ngOnDestroy(): void {
    this.initDate = null;
    document.removeEventListener('mousemove', this.saveLastActivity);
    super.ngOnDestroy();
  }
}
